import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { Block as Component } from '../block';
import type { TBlock, IDeps } from '../models';
import styles from '../styles/mobile.css';

// className прокидывается через переменную classNames
// eslint-disable-next-line styler/check-styler
export const BlockMobile = createWidget<IDeps, TBlock>(
    { styles },
    { priorityStyler: true }
)(Component);
